

    <div class="container-fluid pt-3">
   
        <!-- end page title end breadcrumb -->
       
    
       
    <div class="row">
                    <div class="col-sm-12">
                        <div class="page-title-box">
    
                            <div class="card">
                                <div class="card-header bg-primary text-center text-white">
                                    TOTAL STOCK
                                </div>
                                <div class="card-body1">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr class="bg">
                                                <th>
                                                    Date</th>
                                                <th>	Material</th>
                                                <th>Description	</th>
                                                <th>     IN</th>
                                                <th>   OUT</th>
                                                <th>    BAL</th>
    
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                       
                                        <tbody>
                                     
                                        
                                           
                                        
                                            <tr>
                                                <th scope="row">2022-01-03 10:51:35</th>
                                                <td>INK CT BOPP</td>
                                                <td>       INK CT BOPP	</td>
                                                <td>    734.55 Kgs</td>
                                                <td> 0 Kgs</td>
                                                <td>1244523.38</td>
                                                <td>
                                               
                                                  <!-- <i class="las la-pen text-secondary font-16"></i>
                                                  
                                               <i class="las la-trash-alt text-secondary font-16"></i> -->
                                                </td>
                                            </tr>
                                       
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div><!--end col-->
                    </div><!--end row-->
    
                </div><!-- container -->
            </div>
        